import ActiveValue from "~types/ActiveValue";

function getLearnMoreContent(id: number, valueList: Array<ActiveValue>) {
  const statementObj = valueList.filter(
    valueStatement => valueStatement.statementId === id
  );
  return statementObj[0].learnMoreContent;
}

export default getLearnMoreContent;
